module.exports = __webpack_public_path__ + "img/step.0b4e3597.png";